import Api from 'src/api/Base'

class GetStoreDetailsByStoreNumber extends Api {
  requestUrl = `/api/store/storeNumber/${this.getParams().storeNumber}`
}

export default GetStoreDetailsByStoreNumber
